import React from "react";
import { IPetsyHeadingProps } from "./PetsyHeading.types";
import {
  useFlowData,
  FlowTypes,
  PopupTip,
  Icon,
  IconColorStyle,
  IconSize
} from "@adaptis/flow-components";
import { tips } from "../PopupTips/tips";
import _ from "../../imports/lodash-imports";
import "./PetsyHeading.scss";
import { pushDataToGTM } from "../../KnoseAPI/Lib/Utils";
import { getGTMQuoteData } from "../../util/helper-functions";

export default function PetsyHeading(props: IPetsyHeadingProps) {
  const { setData, getData, getDataFromArray, injectData } = useFlowData();
  const tip = props.tipName ? _.get(tips, props.tipName) : undefined;
  const [isValidPetAge, setIsValidPetAge] = React.useState<boolean>(true);

  React.useEffect(() => {
    // pushDataToGTM(getGTMQuoteData(), "Quote Details");
    const petAgeOnStartDatePolicy = getData("petAgeOnStartDatePolicy");

    // 1094 = 2years + 364 days (1 year = 365 days)
    if (props.isCheckPetAge && petAgeOnStartDatePolicy > 1094) {
      setIsValidPetAge(false);
    }
  }, []);

  return (
    <>
      {isValidPetAge && <>
        <div
          data-testid="Heading"
          className={
            "flc_petsy_heading d-flex " + (props.className ? props.className : "")
          }
        >
          {props.image && (
            <Icon
              className="me-2"
              src={props.image ?? ""}
              colorStyle={IconColorStyle.Heading}
              size={IconSize.Medium}
            />
          )}
          <div className="align-self-center">{injectData(props.title)}</div>
          {props.tipName && <PopupTip className="ms-3" tip={tip} />}
        </div>
        {props.content && <p className="mb-0">{props.content}</p>}
      </>}
    </>
  );
}
